export const isOpenRequest = (t) => !!t.assign_request && !t.assigned_driver_id && !t.assigned_driver_name && !/complete|cancel|no_show/i.test(t.status || "");

export const REQUESTS_CHANGED = "rs:assign-requests-changed";
